export const TRANSACTIONS_PER_PAGE = 25;